import { render, staticRenderFns } from "./StockByCustomer.vue?vue&type=template&id=de1eb17e&scoped=true&"
import script from "./StockByCustomer.vue?vue&type=script&lang=js&"
export * from "./StockByCustomer.vue?vue&type=script&lang=js&"
import style0 from "./StockByCustomer.vue?vue&type=style&index=0&id=de1eb17e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de1eb17e",
  null
  
)

export default component.exports